import { parseCookie } from "cookie";

const tokensFromCookie = (cookies = []) => {
  let srcObj = parseCookie(document.cookie);

  let result = cookies.reduce(
    (obj, cookie) => ({
      ...obj,
      [cookie]: srcObj[cookie],
    }),
    {}
  );
  return result;
};

export default tokensFromCookie;
